import React from "react";
import { Link } from "react-router-dom";
import { StarDivider } from "../components/Ornaments";
import { SEO } from "../components/SEO";
import { usePageContent, resolveMediaUrl } from "../components/PageContent";
import { usePageBlocks, PageBlocksRenderer } from "../components/PageBlocks";

export default function About() {
  const c = usePageContent("about", {
    eyebrow: "A pamphlet of partial honesty",
    subtitle: "— Dr. Chibah's —",
    title: "What The Hell\nIs Chibah?",
    body: "A Compendium · Volume the First · 25¢",
  });
  const blocks = usePageBlocks("about");
  const bg = resolveMediaUrl(c.image);

  return (
    <div className="bg-bone" data-testid="about-page">
      <SEO title={c.title?.replace("\n", " ") || "What The Hell Is Chibah?"} description={c.body} image={bg} path="/what-the-hell" />
      <section
        className="bg-card-light border-b-4 border-asphalt py-20 relative overflow-hidden"
        style={
          c.show_media && bg
            ? { backgroundImage: `url(${bg})`, backgroundSize: "cover", backgroundPosition: "center" }
            : undefined
        }
        data-testid="about-hero"
      >
        {c.show_media && bg && c.overlay && (
          <div className="absolute inset-0 bg-bone/85 pointer-events-none" />
        )}
        <div className="relative max-w-3xl mx-auto px-5 lg:px-0 text-center">
          {c.eyebrow && <div className="font-mono text-xs uppercase tracking-[0.4em] mb-4">{c.eyebrow}</div>}
          {c.subtitle && <div className="font-western text-4xl sm:text-5xl mb-6">{c.subtitle}</div>}
          <h1 className="font-display text-6xl sm:text-7xl uppercase tracking-tighter leading-[0.95] whitespace-pre-line">
            {c.title}
          </h1>
          <StarDivider className="text-asphalt mt-8 mb-6" />
          {c.body && <p className="font-mono text-xs uppercase tracking-[0.3em] whitespace-pre-line">{c.body}</p>}
        </div>
      </section>

      <PageBlocksRenderer blocks={blocks} testid="about-blocks" />

      <section className="max-w-3xl mx-auto px-5 lg:px-0 py-16">
        <p className="font-western text-3xl text-ink mb-8 leading-snug">
          Chibah is a skateboarding company. Chibah is also a clubhouse, a P.O. box, a zine, a podcast that doesn't
          exist yet, and a complaint department for the road.
        </p>
        <p className="font-body text-lg leading-relaxed text-ink mb-6">
          We started in 2019 in a friend's garage in San Bernardino. We pressed two decks, broke one, sold the other to
          a stranger at a 7-Eleven for $40 and a bag of beef jerky. We did not have a business plan. We still do not
          have a business plan. We have a P.O. box and a Vandercook and a 1994 Chevy Astro with 217,000 miles on it.
        </p>
        <p className="font-body text-lg leading-relaxed text-ink mb-6">
          "Chibah" doesn't mean anything in any language we know. We picked it because it sounded like a place you
          could end up by accident. A bus terminal in a town you weren't planning to stop in. We've been there a few
          times. You probably have, too.
        </p>

        <div className="border-y-4 border-asphalt my-10 py-10 bg-card-light px-6">
          <div className="font-mono text-xs uppercase tracking-[0.35em] mb-3 text-terra">✦ Our Promise to You</div>
          <ul className="font-western text-2xl text-ink space-y-4 list-decimal list-inside">
            <li>We will mail you a skateboard.</li>
            <li>It will arrive bent or perfect, depending on the postal mule.</li>
            <li>We will publish stories that are mostly true.</li>
            <li>We will not optimize you. We will not target you. We will not retarget you.</li>
            <li>We will tell at least one joke per email.</li>
            <li>If the joke is bad, we will not apologize.</li>
          </ul>
        </div>

        <h2 className="font-display text-4xl uppercase tracking-tighter mb-4">Things we make</h2>
        <p className="font-body text-lg text-ink mb-3">Decks. Wheels. Hats. T-shirts. Prints. The occasional zine. Sometimes a podcast we forget to upload.</p>
        <h2 className="font-display text-4xl uppercase tracking-tighter mt-10 mb-4">Things we don't make</h2>
        <p className="font-body text-lg text-ink mb-3">NFTs. Apps. Wellness drinks. Branded content. Subscription boxes. A clean reputation.</p>

        <div className="mt-14 text-center">
          <Link
            to="/complain"
            className="inline-flex items-center gap-3 bg-terra text-bone border-2 border-asphalt px-7 py-4 font-display tracking-wider uppercase text-xl shadow-hard hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0_#1C1B1A] transition-all"
          >
            Tell us what's wrong with this
          </Link>
        </div>
      </section>
    </div>
  );
}
